export default __webpack_public_path__ + "static/media/raki_detail7.be064107.jpg";